import { render } from "./dxgladd.vue?vue&type=template&id=e762abf2&scoped=true"
import script from "./dxgladd.vue?vue&type=script&lang=js"
export * from "./dxgladd.vue?vue&type=script&lang=js"

import "./dxgladd.vue?vue&type=style&index=0&id=e762abf2&lang=scss&scoped=true"
import "./dxgladd.vue?vue&type=style&index=1&id=e762abf2&scoped=true&lang=css"

import exportComponent from "D:\\workCode\\web-backEnd\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e762abf2"]])

export default __exports__